import { FC, ReactNode } from "react"
import classNames from "classnames"
import Modal from "@/components/shared/Modal"
import { ColorVariant } from "@/types/index"
import "./index.scss"

export interface DualPanelModalProps {
   open: boolean
   variant: ColorVariant
   infoSection: ReactNode
   actionSection: ReactNode
   onClose: () => void
   centered?: boolean
}

const DualPanelModal: FC<DualPanelModalProps> = ({
   open,
   variant,
   infoSection,
   actionSection,
   onClose,
   centered = false,
}) => {
   return (
      <Modal
         open={open}
         handleClose={onClose}
      >
         <div className="dual-panel-modal">
            <div
               className={classNames(
                  "dual-panel-modal__info-panel",
                  `dual-panel-modal__info-panel--${variant.replace("--", "")}`,
                  { "dual-panel-modal__info-panel--centered": centered }
               )}
            >
               {infoSection}
            </div>
            <div
               className={classNames("dual-panel-modal__action-panel", {
                  "dual-panel-modal__action-panel--centered": centered,
               })}
            >
               {actionSection}
            </div>
         </div>
      </Modal>
   )
}

export default DualPanelModal
